import React, { useState } from "react";
import TemporaryLaunchPage from "./TemporaryLaunchPage";
import {
  grantTemporaryLaunchAccess,
  hasTemporaryLaunchAccess,
} from "./launchGateAccess";

type TemporaryLaunchGateProps = {
  children: React.ReactNode;
};

const TemporaryLaunchGate = ({ children }: TemporaryLaunchGateProps) => {
  const [hasAccess, setHasAccess] = useState(hasTemporaryLaunchAccess);

  if (hasAccess) {
    return <>{children}</>;
  }

  return (
    <TemporaryLaunchPage
      onAccessGranted={() => {
        grantTemporaryLaunchAccess();
        setHasAccess(true);
      }}
    />
  );
};

export default TemporaryLaunchGate;
